import {createContext} from 'react';

interface ItemBankRefsContextValue {
  registerItemEl: (id: string, el: HTMLElement | null) => void;
  registerSlotEl: (id: string, el: HTMLElement | null) => void;
}

export const ItemBankRefsContext = createContext<ItemBankRefsContextValue>({
  registerItemEl: () => {},
  registerSlotEl: () => {}
});
